import { render, staticRenderFns } from "./author-questionnaire.dialog.vue?vue&type=template&id=509ca8cf&scoped=true"
import script from "./author-questionnaire.dialog.vue?vue&type=script&lang=js"
export * from "./author-questionnaire.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ca8cf",
  null
  
)

export default component.exports